var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback } from "react";
import pubsub from "@viewlift/pubsub";
import { SEARCH_EVENTS, SEARCH_KEYS } from "../../types/StandaloneSearchTypes";
import { StandaloneSearch } from "./StandaloneSearch";
import { useNavigate } from "react-router-dom";
import { getVideoRedirectLink } from "../../components/sliderCore/helpers/getVideoRedirectLink";
import { getStorageItem, removeStorageItem, setStorageItem } from "../../helpers/storageManager";
export var useStandaloneSearchHelper = function () {
    var navigate = useNavigate();
    var manageTrayVisibility = function (elClassName, displayState) {
        var trays = document.getElementsByClassName(elClassName);
        if (trays.length <= 1)
            return;
        for (var i = 1; i < trays.length; i++) {
            trays[i].style.display = displayState;
        }
    };
    var recentSearchHandler = function (event, key, searchWord) {
        var _a;
        if (event === SEARCH_EVENTS.UPDATE) {
            if (!searchWord)
                return;
            var _temp = (_a = localStorage.getItem(key)) === null || _a === void 0 ? void 0 : _a.split(",");
            if (_temp) {
                _temp.push(searchWord);
                return localStorage.setItem(key, _temp.reverse().join());
            }
            return localStorage.setItem(SEARCH_KEYS.RECENT_SEARCH_TERMS, searchWord);
        }
        if (event === SEARCH_EVENTS.GET)
            return localStorage.getItem(key);
        if (event === SEARCH_EVENTS.DELETE) {
            manageTrayVisibility("vl_search_tray_row", "block");
            localStorage.removeItem(key);
            return pubsub.publish(SEARCH_EVENTS.DELETE, "");
        }
    };
    var manageOverlayElement = function (actionConfig) {
        if (!actionConfig)
            return;
        actionConfig.forEach(function (_a) {
            var actionType = _a.actionType, elementId = _a.elementId;
            var element = document.getElementById(elementId);
            if (!element)
                return;
            if (actionType === "show")
                return element.classList.remove("hide");
            return element.classList.add("hide");
        });
    };
    var groupByContentType = function (data) {
        var _a, _b;
        if (!((_b = (_a = data === null || data === void 0 ? void 0 : data.search) === null || _a === void 0 ? void 0 : _a.records) === null || _b === void 0 ? void 0 : _b.length))
            return;
        var groupedData = {};
        data.search.records.forEach(function (obj) {
            var contentType = obj.gist.contentType;
            if (!groupedData[contentType]) {
                groupedData[contentType] = [];
            }
            groupedData[contentType].push(obj);
        });
        return groupedData;
    };
    var clearPreviousSearch = useCallback(function (key, cb) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            recentSearchHandler(SEARCH_EVENTS.DELETE, key);
            localStorage.removeItem(SEARCH_KEYS.SEARCH_DATA);
            localStorage.removeItem(SEARCH_KEYS.RECENT_SEARCH_TERMS);
            removeStorageItem(SEARCH_KEYS.RECENT_SEARCH_DATA);
            //localforage.removeItem(SEARCH_KEYS.RECENT_SEARCH_DATA).then(cb).catch(console.error);
            manageOverlayElement([
                { actionType: "hide", elementId: "searchResultContainer" },
                { actionType: "hide", elementId: "wrapperOverlay" },
            ]);
            return [2 /*return*/];
        });
    }); }, []);
    /**
     * Initializes a stre for recent search data as an empty array if
     * there key SEARCH_KEYS.RECENT_SEARCH_DATA is not found in localStorage
     * @returns {void}
     */
    var initRecentSearchDataStore = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setStorageItem(SEARCH_KEYS.RECENT_SEARCH_DATA, { items: [] });
            return [2 /*return*/];
        });
    }); };
    /**
     * A function that gets data for SEARCH_KEYS.RECENT_SEARCH_DATA key from localStorage.
     * If it does not exist, a new store is initialized using initRecentSearchDataStore function
     * @returns {RECORD[] | null}
     */
    var getRecentSearchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = getStorageItem(SEARCH_KEYS.RECENT_SEARCH_DATA);
                    if (!!data) return [3 /*break*/, 2];
                    return [4 /*yield*/, initRecentSearchDataStore()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, undefined];
                case 2: return [2 /*return*/, data];
            }
        });
    }); };
    var setRecentSearchData = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, setStorageItem(SEARCH_KEYS.RECENT_SEARCH_DATA, data)];
        });
    }); };
    /**
     * Updates an already existing recentSearchData store in the localStorage
     * when user clicks any search result card on the UI.
     * @param data
     * @returns
     */
    var updateRecentSearchData = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _oldData, filteredSearch;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getRecentSearchData()];
                case 1:
                    _oldData = _b.sent();
                    if (!_oldData)
                        return [2 /*return*/, setRecentSearchData({ items: [data] })];
                    filteredSearch = (_a = _oldData === null || _oldData === void 0 ? void 0 : _oldData.items) === null || _a === void 0 ? void 0 : _a.filter(function (content) { return (content === null || content === void 0 ? void 0 : content.id) != (data === null || data === void 0 ? void 0 : data.id); });
                    pubsub.publish(SEARCH_KEYS.RECENT_SEARCH_DATA, undefined);
                    return [2 /*return*/, setRecentSearchData({ items: __spreadArray([data], __read(filteredSearch), false) })];
            }
        });
    }); };
    var onItemClickHandler = function (args) {
        return updateRecentSearchData(args.clickedNode).then(function () {
            var url = getVideoRedirectLink(args.clickedNode) || args.url;
            navigate(url);
        });
    };
    return {
        manageOverlayElement: manageOverlayElement,
        groupByContentType: groupByContentType,
        recentSearchHandler: recentSearchHandler,
        clearPreviousSearch: clearPreviousSearch,
        manageTrayVisibility: manageTrayVisibility,
        initRecentSearchDataStore: initRecentSearchDataStore,
        getRecentSearchData: getRecentSearchData,
        updateRecentSearchData: updateRecentSearchData,
        onItemClickHandler: onItemClickHandler,
    };
};
export default StandaloneSearch;
